import { useEffect, useRef, useState } from "react";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import useUpdate from "../../hooks/useUpdate";
import useSendPushNotification from "../../hooks/useSendPushNotification";

// CUSTOM SERVICES
import apiRequest from "../../services/apiService";


//COOKIE 
import Cookies from 'js-cookie';

// CONTEXT
import { useAuth } from '../../contexts/AuthContext';


import { updateTransaction} from "../../graphql/mutations";
import { generateClient } from "aws-amplify/api";


const Certificate = ({ details,currentTransactionId }) => {
  const client = generateClient();


  const { user } = useAuth();
  const lawyerId = user.user_id;


  const { updateData, isLoading, errorMessage, successMessage, responseData } = useUpdate('patch');
  const { sendPushNotification, response, error } = useSendPushNotification();


  const [principalImage, setPrincipalImage] = useState("");
  const [adminImage, setAdminImage] = useState("");
  useEffect(() => {
    const savedAdminImage     = localStorage.getItem('admin_image');
    const savedPrincipalImage = localStorage.getItem('principal_image');
    if(savedAdminImage) {
      setAdminImage(savedAdminImage);
    }
    if(savedPrincipalImage) {
      setPrincipalImage(savedPrincipalImage);
    }
  }, []);


  const [fetchErrorMessage, setFetchErrorMessage] = useState(null);

  const [data,setData] = useState('');
  useEffect(() => {
    const loadTransaction = async () => {
      try {
        const data = await apiRequest('get', `/transactions/${details.transactionId}/`);
        setData(data);
      } catch (error) {
        setFetchErrorMessage(error.message)
      }
    };

    loadTransaction();
  }, [details]);
  
   

  const printableBusinessPermitRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successStatus, setSuccessStatus] = useState("")
  const printBusinessPermit = async () => {
    
    setIsSubmitting(true);

    console.log(lawyerId);
    try {
      const canvas = await html2canvas(printableBusinessPermitRef.current);

      const imgData = canvas.toDataURL('image/png');

      // Create a new jsPDF instance
      const pdf = new jsPDF();
      pdf.setFillColor(null);
      pdf.addImage(imgData, 'PNG', 10, 10, 190, 0); // Adjust the position and size as needed

      // Convert the PDF to a Blob
      const pdfBlob = pdf.output('blob');

      // Create a FormData object
      const formData = new FormData();
      formData.append('pdf', pdfBlob, `${details.transactionId}.pdf`);
      formData.append('document_id', details.transactionId); // Replace with the actual document ID
      formData.append('released_by_id', lawyerId);
      formData.append('recipient_email', details.email);

      
      try {
        const url = `${process.env.REACT_APP_API_URL}/transactions/upload_pdf/`
        await updateData(url, formData, (responseData) => {
      
          if (responseData) {
            setSuccessStatus(responseData.status)

            if(responseData.status==="success"){
              updateCurrentTransactionToReleased()
            }
          }
        });
 

      } catch (error) {
        console.error('Update failed:', error);
      }


    } catch (error) {
      console.error('Error generating or uploading PDF:', error);
    }
    finally {
      setIsSubmitting(false);
    }

  };


 

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-based, so we add 1
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const updateCurrentTransactionToReleased = async () => {
    console.log(currentTransactionId);

    const currentTime = new Date();

    const updateVariables = {
      input: {
        id: currentTransactionId,
        transaction_status: "RELEASED",
        date_released:formatDate(currentTime),
        released_by_id:lawyerId
      },
      condition: {
        id: { eq: currentTransactionId },
      },
    };

    // Step 3: Call the update mutation
    const updateResponse = await client.graphql({
      query: updateTransaction, // The mutation to update the user status
      variables: updateVariables,
    });

    console.log(
      "User status updated:",
      updateResponse.data.updateTransaction
    );
  };



  return (
    <>
      {details && data && (
        <div key={details.participantId} className="col-md-6">
          <button
            className="btn btn-info"
            type="button"
            disabled={isSubmitting}
            onClick={() => {
              printBusinessPermit();
              sendPushNotification(
                data.user_transacted.registration_id,
                "",
                "Permit Info",
                `Your certification has been released.`,
                "PERMIT RELEASED",
                "notification_user"
              );
            }}
          >
            {isSubmitting ? (
              <>
                <span className="spinner-grow me-1" role="status" aria-hidden="true"></span>Sendings Certificate...
              </>
            ) : successStatus === "success" ? (
              <>
                <span className="" role="status" aria-hidden="true"></span>Re-send Certificate
              </>
            ) : (
              <>
                <span className="" role="status" aria-hidden="true"></span>Send Certificate
              </>
            )}
          </button>

          {successStatus === "success" ? (
            <span className="badge rounded-pill bg-success ms-2" title="Status">
              Certificate has been sent <i className="bx bx-check"></i>
            </span>
          ) : (
            <span className="badge rounded-pill bg-danger ms-2" title="Status">
              Certificate is not sent {successStatus} <i className="bx bx-x"></i>
            </span>
          )}

          <div
            ref={printableBusinessPermitRef}
            className="m-0 d- bg-white col-md-6"
            style={{
              padding: "13px",
              paddingTop: 0,
              paddingBottom: 0,
              minWidth: 850,
            }}
          >
            <div
              className="row header py-4 my-4  bg-white"
              style={{ height: "115px" }}
            >
              <div className="col ms-4">
                <img
                  src="/iusevolutione/assets/img/jurat_cert/logo.png"
                  alt="Logo"
                  className="img-fluid"
                  style={{
                    height: "120px",
                    width: "350px",
                    maxWidth: 350,
                  }}
                />
              </div>

              <div className="col text-center me-2  ">
                <img
                  src="/iusevolutione/assets/img/bahay_toro/lungsod_quezon_logo.png"
                  alt="Logo"
                  className="img-fluid d-none"
                />
              </div>
            </div>
            <div
              className="row m-0  bg-white"
              style={{
                // backgroundImage: "url('/iusevolutione/assets/img/bahay_toro/bahaytoro_logo_body.png')",
                // backgroundSize: "cover", // or "cover" depending on your needs
                // backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "920px", // Set your desired height
                width: "100%",
              }}
            >
              <div className="col  bg-white">
                <div className="col-12 h-auto bg-white">
                  <div className="content mx-4 bg-white">
                    <div>
                      <p className="fs-1">
                        <b>
                          E-CERTIFICATE{" "}
                          {details?.documentName?.toUpperCase() ?? ""}
                        </b>
                      </p>
                      <p>
                        THIS CERTIFIES that a document together with its
                        attachments, with ID No. 
                        {details?.transaction_id ?? ""}

                        , stored/reflected under the QR Code with serial number
                        {details?.transaction_id ?? ""}
                         was electronically
                        processed by this system, using the electronic notary, a mobile
                        app of the Digital Jurat Facility, operated and managed
                        by the Notaryo Publiko, pursuant
                        to the digitalization program of the government, and in
                        accordance with government protocols.
                      </p>
                      <p>
                        Specifically, the electronic notary was used, availed of, or
                        resorted to, on the date and place's reflected in the QR
                        Code, which enabled the duly designated Administering
                        Officer of the government agency, or the
                        court-commissioned Notary Public in the area, to
                        electronically meet face-to-face, as the mandated
                        "swearing to an oath" was being done or conducted under
                        the formalities required thereto.
                      </p>
                      <p className="font-italic">
                        (Note: This certification is systems-generated and does
                        not need any signature on the face of this paper.)
                      </p>
                    </div>

                    <div className="mt-5">
                      <div className="row footer">
                        <div className="col-12 text-start">
                          <div className="col-12 d-flex justify-content-start">
                            <div
                              className="card bg-label-info"
                              style={{ maxWidth: 220 }}
                            >
                              <img
                                className="card-img-top m-2"
                                src={`data:image/jpeg;base64,${adminImage}`}
                                alt="Admin Officer"
                                style={{ width: "205px", height: "350px" }}
                              />
                              <div className="card-body  p-0">
                                <p className="card-text text-center text-bold">
                                  Laywer
                                </p>
                              </div>
                            </div>

                            <div
                              className="card ms-2 bg-label-danger"
                              style={{ maxWidth: 220 }}
                            >
                              <img
                                className="card-img-top m-2"
                                src={`data:image/jpeg;base64,${principalImage}`}
                                alt="Principal"
                                style={{ width: "205px", height: "350px" }}
                              />
                              <div className="card-body  p-0">
                                <p className="card-text text-center text-bold">
                                  Principal
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row header align-items-center d-  bg-white"
              style={{
                backgroundImage:
                  "url('/iusevolutione/assets/img/jurat_cert/footer.png')",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "200px",
              }}
            ></div>
          </div>
        </div>
      )}
    </>
  );
}

export default Certificate;